<div>
  <div class="arrow"></div>
  <div class="tooltip-content">
    <ng-content></ng-content>
  </div>
</div>